var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEqixIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EF2E31;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.9,531.5v-195h131.4v34h-90.2v46.5h83.4v34h-83.4v46.6h90.6v34H146.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M480.8,433.9c0,21.3-4,39.4-12,54.3c-8,14.9-19,26.3-32.8,34.1c-13.8,7.8-29.3,11.8-46.5,11.8 c-17.3,0-32.9-3.9-46.7-11.8c-13.8-7.9-24.7-19.3-32.7-34.2c-8-14.9-12-33-12-54.2c0-21.3,4-39.4,12-54.3 c8-14.9,18.9-26.3,32.7-34.1c13.8-7.8,29.3-11.8,46.7-11.8c17.2,0,32.7,3.9,46.5,11.8c13.8,7.8,24.7,19.2,32.8,34.1 C476.8,394.6,480.8,412.7,480.8,433.9z M439,433.9c0-13.8-2-25.4-6.1-34.9c-4.1-9.5-9.9-16.6-17.3-21.5 c-7.4-4.9-16.1-7.3-26.1-7.3c-10,0-18.7,2.4-26.1,7.3c-7.4,4.9-13.2,12.1-17.3,21.5c-4.1,9.5-6.1,21.1-6.1,34.9 c0,13.8,2,25.4,6.1,34.9c4.1,9.5,9.9,16.6,17.3,21.5c7.4,4.9,16.1,7.3,26.1,7.3c10,0,18.7-2.4,26.1-7.3 c7.4-4.9,13.2-12.1,17.3-21.5C436.9,459.3,439,447.7,439,433.9z M375.2,463.7h35l17.6,22.7l17.3,20.2l32.7,41h-38.5l-22.5-27.6 l-11.5-16.4L375.2,463.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M543,336.4v195h-41.2v-195H543z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M606,336.4l39.3,66.5h1.5l39.5-66.5H733l-59.5,97.5l60.9,97.5h-47.4l-40-66.6h-1.5l-40,66.6h-47.2l61-97.5 l-59.9-97.5H606z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqixIcon);
export default __webpack_public_path__ + "static/media/eqix_icon.8fe4ae2a6aed55ae705a326e4e46e827.svg";
export { ForwardRef as ReactComponent };